import { render, staticRenderFns } from "./PromoPrixTerminal.vue?vue&type=template&id=d32fd362"
import script from "./PromoPrixTerminal.vue?vue&type=script&lang=js"
export * from "./PromoPrixTerminal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports